import { Workbook } from "exceljs";
import {
  excelHelper,
  fileHelper,
  formatHelper,
} from "../../../../common/helpers";

/**
 *
 * @param {any[]} paymentDetailedBalance
 * @returns {Workbook}
 */
export const exportExcel = async (
  paymentDetailedBalance,
  selectedStore,
  startDate,
  endDate
) => {
  const excelData = [];

  for (let item = 0; item < paymentDetailedBalance.length; item++) {
    const balance = paymentDetailedBalance[item];
    excelData.push({
      order: item + 1,
      createdAt: balance.created_at,
      receiptId: balance.receipt_id,
      store: balance.store,
      customer: balance.customer,
      totalNet: balance.total_net,
      receiptType: balance.receipt_type,
      paymentType: balance.sell_payment_type,
      cashPayed: balance.cash_payed,
      cardPayed: balance.card_payed,
      cardType: balance.card_type,
      detail: balance.detail,
    });
  }

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR FORMA DE PAGO DETALLADO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "createdAt",
            outValue: "FECHA",
          },
          {
            inValue: "receiptId",
            outValue: "CORRELATIVO",
          },
          {
            inValue: "store",
            outValue: "SEDE",
          },
          {
            inValue: "customer",
            outValue: "CLIENTE",
          },
          {
            inValue: "totalNet",
            outValue: "MONTO DE VENTA",
          },
          {
            inValue: "receiptType",
            outValue: "TIPO DE DOCUMENTO",
          },
          {
            inValue: "paymentType",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "cashPayed",
            outValue: "PAGO CON EFECTIVO",
          },
          {
            inValue: "cardPayed",
            outValue: "PAGO CON TARJETA",
          },
          {
            inValue: "cardType",
            outValue: "TIPO DE TARJETA",
          },
          {
            inValue: "detail",
            outValue: "DETALLES DE VENTA",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileName(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileName = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-general-por-metodo-de-pago_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-detallado-por-metodo-de-pago_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};

/**
 *
 * @param {any[]} paymentBalance
 * @returns {Workbook}
 */
export const exportExcelGeneral = async (
  paymentBalance,
  selectedStore,
  startDate,
  endDate
) => {
  let totalQuantity = 0;
  let totalIncome = 0;

  const excelData = [];

  for (let item = 0; item < paymentBalance.length; item++) {
    const balance = paymentBalance[item];

    excelData.push({
      order: item + 1,
      name: balance.name,
      quantity: balance.quantity,
      total: balance.total,
    });

    totalQuantity += balance.quantity;
    totalIncome += balance.total;
  }

  excelData.push({
    order: "",
    name: "TOTAL",
    quantity: totalQuantity,
    total: totalIncome,
  });

  const json = excelHelper.jsonToJson(
    [excelData],
    [
      {
        name: "BALANCE POR FORMA DE PAGO",
        props: [
          {
            inValue: "order",
            outValue: "",
          },
          {
            inValue: "name",
            outValue: "FORMA DE PAGO",
          },
          {
            inValue: "quantity",
            outValue: "CANTIDAD",
          },
          {
            inValue: "total",
            outValue: "TOTAL RECAUDADO",
          },
        ],
      },
    ]
  );
  const workbook = excelHelper.jsonToExcelJs(json);
  const fileName = getFileNameGeneral(selectedStore, startDate, endDate);
  const blob = await excelHelper.workbookToBlob(workbook);
  fileHelper.downloadBlob(blob, fileName);
};

const getFileNameGeneral = (selectedStore, startDate, endDate) => {
  const storeName = selectedStore.label;
  return selectedStore.value == 0
    ? formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-general-por-metodo-de-pago_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx"
    : formatHelper.toDateYYMMDD(new Date().toUTCString()) +
        "_reporte-por-metodo-de-pago_" +
        storeName.toLowerCase() +
        "_" +
        formatHelper.toDateYYMMDD(startDate._d) +
        "_" +
        formatHelper.toDateYYMMDD(endDate._d) +
        ".xlsx";
};



// WEBPACK FOOTER //
// ./src/scenes/Report/Balance/PaymentBalance/excel.js